import React, { useCallback, useEffect, useState } from "react";
import { wire } from "react-hot-wire";
import { WithTranslation, withTranslation } from "react-i18next";

import { Job } from "models/job/Job";
import { JobService } from "services/job/Job.service";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useQuery } from "@tanstack/react-query";

export type JobLogsProps = {
  job: Job;
  setApplicationState: Function;
  jobService: JobService;
} & WithTranslation;

export const JobLogs = ({
  job,
  setApplicationState,
  jobService,
  t
}: JobLogsProps) => {
  const query = useQuery(
    ["job", job.id],
    () => jobService.fetchJob({ id: job.id }),
    {
      refetchInterval: 5000
    }
  );
  const [
    logsContainerRef,
    setLogsContainerRef
  ] = useState<HTMLDivElement | null>(null);
  const ref = useCallback((node: HTMLDivElement) => {
    if (node) {
      setLogsContainerRef(node);
    }
  }, []);

  useEffect(() => {
    if (query.data) {
      setApplicationState(query.data.state);
    }
  }, [setApplicationState, query.data]);

  useEffect(() => {
    if (logsContainerRef) {
      const { scrollHeight, scrollTop, offsetHeight } = logsContainerRef;

      if (scrollHeight - (scrollTop + offsetHeight) > 0) {
        logsContainerRef.scrollTop = logsContainerRef.scrollHeight;
      }
    }
  }, [query.data, logsContainerRef]);

  return (
    <div className="modal-body overflow-auto" style={{ height: 0 }} ref={ref}>
      {query.isLoading === undefined ? (
        <div className="d-flex align-items-center justify-content-center h-100">
          <CircularProgress />
        </div>
      ) : (
        <pre style={{ whiteSpace: "pre-wrap" }}>
          {query.data && query.data.log
            ? query.data.log
            : t("application.preview.emptyLogs")}
        </pre>
      )}
    </div>
  );
};

export default wire(["jobService"], withTranslation()(JobLogs));
